import { render, staticRenderFns } from "./testimonial-content-block.ts.vue?vue&type=template&id=134f3870&scoped=true&"
import script from "./testimonial-content-block.ts.vue?vue&type=script&lang=ts&"
export * from "./testimonial-content-block.ts.vue?vue&type=script&lang=ts&"
import style0 from "./testimonial-content-block.ts.vue?vue&type=style&index=0&id=134f3870&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134f3870",
  null
  
)

export default component.exports